var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vbutton',{staticClass:"new-assessment",attrs:{"label":_vm.$tr('vacancy.settings.talentq.project-new-block'),"color":"grey","type":"add"},on:{"click":function($event){return _vm.$emit('add_assessment')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }